import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

type BillingCustomerState = {
  selectedCustomerId: number | null
}

const initialState: BillingCustomerState = {
  selectedCustomerId: null,
}

const billingCustomerSlice = createSlice({
  name: "billingCustomer",
  initialState,
  reducers: {
    setSelectedCustomerId: (state, action: PayloadAction<number | null>) => {
      state.selectedCustomerId = action.payload
    },
  },
})

export const { setSelectedCustomerId } = billingCustomerSlice.actions
export const billingCustomerReducer = billingCustomerSlice.reducer
